import { diContainer } from '../DIContainer';
import { AppStorageKey } from '../types';
import { I18n } from '../wrappers/I18n';
import Store from '../wrappers/Store';
import ApiService from './ApiService';
import moment from 'moment-timezone';
const AuditLogService = {
    /**
     * Add log line
     */
    async info(data) {
        const tenant = Store.get('tenant');
        if (!tenant?.venue)
            return false;
        const user = Store.get('user');
        const date = moment().format('YYYY-MM-DD HH:mm:ss');
        const text = I18n.t(`log.${data.type}`, data);
        data = {
            ...data,
            userId: user?.id || null,
            date
        };
        const logLine = `${date}${user ? (' ' + user.name + ':') : ''} ${text}|${JSON.stringify(data)}`;
        let log = await this.getLog();
        log = log ? (log + '\n' + logLine) : logLine;
        if (!Store.get('isOnline')) {
            this.setLog(log);
            return true;
        }
        try {
            await ApiService.post('/log', { log });
            this.removeLog();
        }
        catch (error) {
            if (log)
                this.setLog(log);
        }
        return true;
    },
    /**
     * Get Log
     */
    async getLog() {
        const appStorage = diContainer.resolve('appStorage');
        return appStorage.local().getItem(AppStorageKey.log);
    },
    /**
     * Set Log
     */
    setLog(log) {
        const appStorage = diContainer.resolve('appStorage');
        appStorage.local().setItem(AppStorageKey.log, log);
    },
    /**
     * Remove Log
     */
    removeLog() {
        const appStorage = diContainer.resolve('appStorage');
        appStorage.local().deleteItem(AppStorageKey.log);
    },
};
export default AuditLogService;
export { AuditLogService };
//# sourceMappingURL=AuditLogService.js.map